import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-month-year-picker',
  templateUrl: './month-year-picker.component.html',
  styleUrls: ['./month-year-picker.component.css']
})
export class MonthYearPickerComponent {
  @Input() minDate: string = '';
  @Input() maxDate: string = '';
  @Input() value: string = '';
  @Input() disabled: boolean = false;

  @Output() valueChange = new EventEmitter<string>();

  monthControl = new FormControl<string>('', {
    nonNullable: true
  });
// new FormControl(this.setMonth(this.value));

  ngOnInit(): void {    
    this.initializeControl();
    this.setMonth(this.value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    debugger;
    let changes1 = changes;
    let dfd = !changes['value'].firstChange;
    if (changes['value'] && !changes['value'].firstChange) {
      this.setValue(this.value);
    }

    if (changes['disabled'] && !changes['disabled'].firstChange) {
      this.toggleDisabledState();
    }
  }

  initializeControl(): void {
    this.monthControl.setValue(this.value || '');

    this.toggleDisabledState();

    this.monthControl.valueChanges.subscribe((val: any) => {
      this.valueChange.emit(val);
    });
  }

  toggleDisabledState(): void {
    if (this.disabled) {
      this.monthControl.disable({ emitEvent: false });
    } else {
      this.monthControl.enable({ emitEvent: false });
    }
  }

  setValue(date: string): void {
    this.monthControl.setValue(date, { emitEvent: false });
  }

  clear(): void {
    this.monthControl.setValue('');
    this.valueChange.emit('');
  }

  setMonth(value: string) {
    const formats = [
      'YYYY-MM-DD',
      'YYYY/MM/DD',
      'YYYY MM DD',

      'YYYY-MM',
      'YYYY/MM',
      'YYYY MM',

      'DD-MM-YYYY',
      'MM/DD/YYYY',

      'YYYYMMDD',

      'DD MMM YYYY',
      'MMMM DD YYYY'
    ];

    const date = moment(value, formats, true);

    if (date.isValid()) {
      // type="month" requires YYYY-MM
      this.monthControl.setValue(
        date.format('YYYY-MM')
      );
    }
  }

  openMonthPicker(input: HTMLInputElement) {
    if (input.showPicker) {
      input.showPicker(); // Chrome/Edge
    } else {
      input.click(); // fallback
    }
  }
}
